module.exports = __webpack_public_path__ + "static/media/default_formal_avatar.761de125.png";